"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectUser = void 0;
const user_1 = require("./user");
const app_module_1 = require("./app.module");
const token_service_1 = require("./token.service");
const user_service_1 = require("./user.service");
const _ = require("lodash");
const baseURL = "/connect-management/user";
class ConnectUser extends user_1.User {
    constructor(params) {
        super();
        Object.assign(this, params);
        this.formatTimestamps();
    }
    formatTimestamps() {
        this.createdAtFormatted = this.createdAt ? moment(this.createdAt).format('MM/DD/YY h:mm A') : this.createdAt;
        this.updatedAtFormatted = this.updatedAt ? moment(this.updatedAt).format('MM/DD/YY h:mm A') : this.updatedAt;
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.id) {
                return yield this.update();
            }
            else {
                return yield this.create();
            }
        });
    }
    create() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
                let response = yield http.post(`${baseURL}`, this.params()).toPromise();
                let json = yield response.json();
                let user = new ConnectUser(json);
                return user;
            }
            catch (err) {
                let json = yield err.json();
                throw json;
            }
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
                let response = yield http.put(`${baseURL}/${this.id}`, this.params()).toPromise();
                let json = yield response.json();
                let user = new ConnectUser(json);
                Object.assign(this, user);
                return this;
            }
            catch (err) {
                let json = yield err.json();
                throw json;
            }
        });
    }
    delete() {
        return __awaiter(this, void 0, void 0, function* () {
            this.deleted = true;
            return yield this.update();
        });
    }
    restore() {
        return __awaiter(this, void 0, void 0, function* () {
            this.deleted = false;
            return yield this.update();
        });
    }
    generatePassword() {
        let service = app_module_1.AppModule.injector.get(user_service_1.UserService);
        this.password = service.generatePassword();
    }
    params() {
        let params = _.pick(this, [
            'organization',
            'email',
            'password',
            'deleted'
        ]);
        return _(params)
            .omit(_.isUndefined)
            .omit(_.isNull)
            .value();
    }
}
exports.ConnectUser = ConnectUser;
//# sourceMappingURL=connect-user.js.map